/* ================================================== */
/* CONTROLLER → Contact
/* ================================================== */

app.controller('contactCtrl', ['$scope', '$http', function($scope, $http) {

	// Inits
	var $form       = $('form[name="contact"]'),
		$modal      = $('.modal'),
		postUrl     = $('[name="action"]', $form).val(),
		redirectUrl = $('[name="redirectOnFailure"]', $form).val(),
		recaptchaSiteKey = $('[name="reCAPTCHA_site_key"]', $form).val();

	$scope.data      = {};
	$scope.submitted = false;
	$scope.thanks    = false;

	$scope.saveResults = function() {

		// Disable submit button
		$scope.submitted = true;

		grecaptcha.ready(function() {
			// Verify reCAPTCHA
			grecaptcha.execute(recaptchaSiteKey, {action: 'contactForm'}).then(function(token) {
				// Send the token to the server for verification
				var data = {
					token: token,
					action: 'contactForm'
				};
				data[csrfTokenName] = csrfTokenValue;
				fetch('/actions/utilities-module/captcha', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(data),
				})
				.then(response => response.json())
				.then(data => {
					if (data === true) {
						// Add & serialize data
						var formData = $form.serialize();

						// Save data 
						// → jQuery AJAX is recommended (following Sprout Forms' documentation)
						$.ajax({
							type: 'POST',
							url: postUrl,
							data: formData,
							dataType: 'json',
							encode: true
						}).done(function(data) {
							// console.log(data);

							// if (data.success == true) {

							// 	// Display thanks message
							// 	$scope.$apply(function(){
							// 		$scope.thanks = true;
							// 	});

							// 	// Scroll top of modal on mobile
							// 	if ($modal.length && breakpointXxs && $(window).width() < $(window).height()) {
							// 		$modal.animate({ scrollTop: 0 }, 200);
							// 	}

							// } else {

							// 	// Reload page
							// 	window.location.replace(redirectUrl);

							// }
						}).fail(function() {
							console.log('fail');
						}).always(function() {
							// console.log('always');

							// Display thanks message
							$scope.$apply(function(){
								$scope.thanks = true;
							});

							// Scroll top of modal on mobile
							if ($modal.length && breakpointXxs && $(window).width() < $(window).height()) {
								$modal.animate({ scrollTop: 0 }, 200);
							}
						});
					} else {
						location.reload();
					}
				});
			});
		});

	}

}]);